module.exports = __webpack_public_path__ + "img/pacote-de-moeda.4b769dd0.svg";